import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { downloadBatchFile } from '../../api/customer/masters/commonMastersApi';
import { LucidLoader } from '../Icons';
import { toast } from 'react-toastify';

const BatchDownloadButton = forwardRef(({ selectedQuote, className, showButton = true }, ref) => {
    const [loader, setLoader] = useState(false);

    const handleClick = async () => {
        console.log("Selected Quote v1 :",selectedQuote);
        try {
            setLoader(true);
            const response = await downloadBatchFile(selectedQuote?._id);
            const blob = new Blob([response], { type: 'application/zip' });
            const downloadUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `batch_download_${selectedQuote?.RefId}_V_${selectedQuote?.version}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            toast.error("Failed to download batch file");
        } finally {
            setLoader(false);
        }
    };

    // Expose handleClick to parent through ref
    useImperativeHandle(ref, () => ({
        triggerDownload: handleClick
    }));

    if (!showButton) return null;

    return (
        <div>
            {!loader ? (
                <button
                    onClick={handleClick}
                    className={`px-3 py-1 h-8 mt-1 w-max whitespace-nowrap bg-primaryColor text-white text-sm rounded ${className || ''}`}
                >
                    Batch download all technical drawings
                </button>
            ) : (
                <button
                    disabled
                    className={`px-3 py-1 h-8 bg-primaryColor text-white text-sm rounded flex items-center justify-center ${className || ''}`}
                >
                    <LucidLoader />
                </button>
            )}
        </div>
    );
});

export default BatchDownloadButton;
